<template>
  <div class="game_switch_list">
    <div
      class="game_switch"
      v-for="(projects, type, index) in type_projects"
      :key="type"
      :class="{ selected: (current ? current.type == type : index === 0) && !is_standard}"
    >
      <div
        :class="{
          game_index_link: type == 1 && (current && current.type != 1),
        }"
        v-if="type == 1"
      >
        <a
          class="game_index"
          v-if="type == 1 && (current && current.type != 1) && !manage"
          href="index.html"
          >{{ $t('common.gameP') }}</a
        >
        <a-popover
          placement="bottomLeft"
          trigger="click"
          :overlayClassName="
            type == 1 && (current && current.type != 1) && !manage
              ? 'arrow_drop_menu'
              : 'drop_menu'
          "
        >
          <a class="game_link">
            <img
              :src="`${$service.static_server}/static/img/${current.code}.png`"
              :onerror="noicon"
              class="game_logo"
              v-if="current && current.type == 1 && current.type == type"
            />
            <span class="name">{{
              current && current.type == type
                ? current.name
                : $t(type == 1?'common.gameP':'common.nongameP')
            }}</span>
            <a-icon type="down" />
          </a>
          <template slot="content">
            <div class="drop_menu_content">
              <div class="game_type_swap" v-if="hasTuiShi"><span @click="()=>{isStop=!isStop}"><a-icon type="swap" />切换至{{isStop?'测试运营':'已停服'}}产品</span></div>
              <div
                class="drop_menu_studio"
                v-for="studio in projects"
                :key="studio.name"
                v-show="(isStop?studio.stops.length:studio.games.length) > 0"
              >
                <label>{{ studio.name }}</label>
                <div class="drop_menu_studio_game">
                  <a
                    v-for="game in (isStop?studio.stops:studio.games)"
                    :key="game.code"
                    :href="
                      manage
                        ? `manage.html?proj=${game.code}`
                        : `game.html?proj=${game.code}`
                    "
                    :class="{ selected: current && game.code == current.code }"
                  >
                    <img
                      :src="
                        `${$service.static_server}/static/img/${game.code}.png`
                      "
                      :onerror="noicon"
                      class="game_logo"
                    /><span>{{ game.name }}</span>
                  </a>
                </div>
              </div>
            </div>
          </template>
        </a-popover>
      </div>
      <div
        :class="{
          game_index_link: type == 1 && (current && current.type != 1),
        }"
        v-else
      >
        <a
          class="game_index"
          v-if="type == 1 && (current && current.type != 1) && !manage"
          href="index.html"
          >{{ $t('common.gameP') }}</a
        >
        <a-popover
          placement="bottomLeft"
          trigger="click"
          :overlayClassName="
            type == 1 && (current && current.type != 1) && !manage
              ? 'arrow_drop_menu'
              : 'drop_menu'
          "
        >
          <a class="game_link">
            <img
              :src="`${$service.static_server}/static/img/${current.code}.png`"
              :onerror="noicon"
              class="game_logo"
              v-if="current && current.type == 1 && current.type == type"
            />
            <span class="name">{{
              current && current.type == type
                ? current.name
                : $t(type == 1?'common.gameP':'common.nongameP')
            }}</span>
            <a-icon type="down" />
          </a>
          <template slot="content">
            <div class="drop_menu_content">
              <a
                v-for="game in projects"
                :key="game.code"
                :href="
                  manage
                    ? `manage.html?proj=${game.code}`
                    : `game.html?proj=${game.code}`
                "
                class="drop_menu_item"
                :class="{ selected: current && game.code == current.code }"
              >
                <img
                  :src="`${$service.static_server}/static/img/${game.code}.png`"
                  :onerror="noicon"
                  class="game_logo"
                />
                <span>{{ game.name }}</span>
              </a>
            </div>
          </template>
        </a-popover>
      </div>
    </div>
    <div :class="{'game_switch': true, 'selected':is_standard}" v-if="$i18n.locale==='zh_CN' && admin && manage">
      <div><a class="game_link" href="#/gstandard">标准模块管理</a></div>
    </div>
  </div>
</template>

<script>
import { Popover } from "ant-design-vue";
import Vue from "vue";
Vue.use(Popover);

import storage from "@/utils/storage";
import { FILTER_PROJECT_CODES } from '@/constants/common';

const STUDIOS = ["雷火", "祝融", "燧人", "青女", "女娲", "玄嚣" ];
export default {
  props: ["manage"],
  computed: {
    code() {
      return this.$service.PROJ_CODE;
    },
    current() {
      let currentGame = _.find(this.projects, { code: this.code });
      if(currentGame) {
        if(currentGame.period==='已退市') {
          this.isStop = true
        }
        else {
          this.isStop = false
        }
      }
      return currentGame;
    },
    is_standard() {
      return this.$route.name==='gstandard'
    },
    admin() {
      return this.$store.state.user?this.$store.state.user.admin:false || false
    },
    projects() {
      if(this.$i18n.locale === 'en_US') {
        return this.$store.state.user.projects
        ? this.$store.state.user.projects.map(p=>({...p, name:p.code==='l26'?'FragPunk':p.code==='l26na'?'FragPunk(NA)':p.name}))
        : this.$store.state.user.projects
      }
      return this.$store.state.user.projects;
    },
    hasTuiShi() {
      let flag = false
      this.projects.forEach(s=>{
        if(s.period==='已退市') {
          flag = true
        }
      });
      return flag
    },
    type_projects() {
      let types = _.groupBy(this.projects, "type");
      let new_types = {};
      if (types[1]) {
        let games = _.groupBy(types[1], "studio");
        let studio_games = [];
        STUDIOS.forEach((studio) => {
          if (games[`${studio}工作室`]) {
            studio_games.push({
              name: studio,
              games: games[`${studio}工作室`].filter(s=>s.period!=='已退市'),
              stops: games[`${studio}工作室`].filter(s=>s.period==='已退市' && FILTER_PROJECT_CODES.indexOf(s.code)<0)
            });
          }
        });
        let other_studios = [];
        Object.keys(games).forEach((studio) => {
          if (STUDIOS.indexOf(studio.substr(0, 2)) < 0) {
            other_studios = other_studios.concat(games[studio]);
          }
        });
        if (other_studios.length > 0) {
          studio_games.push({ name: studio_games.length>0?"更多":"", games: other_studios.filter(s=>s.period!=='已退市'), stops: other_studios.filter(s=>s.period==='已退市' && FILTER_PROJECT_CODES.indexOf(s.code)<0)});
        }
        new_types[1] = studio_games;
      }
      if (types[2]) {
        new_types[2] = types[2];
      }
      return new_types;
    },
  },
  mounted() {},
  data() {
    return {
      isStop: false,
      noicon: 'this.src="' + require("@/assets/img/allgame.png") + '"',
    };
  },
};
</script>

<style lang="less" scoped>
@import "../../assets/less/var.less";
.game_switch_list {
  display: block;
  height: 70px;
  float: left;

  .game_switch {
    display: inline-block;
    height: 100%;
    cursor: pointer;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;

    & > div {
      float: left;
      min-width: 150px;
      text-align: center;
    }
    .game_link {
      width: 100%;
      display: inline-block;
      color: #ccc;
      .game_logo {
        width: 40px;
        height: 40px;
      }
      span.name {
        margin: 0 10px 0 0;
        padding: 0 0 0 10px;
      }
      i {
        font-size: 12px;
      }
    }
    .game_index {
      position: absolute;
      color: #ccc;
      margin: 0 10px 0 0;
      padding: 0 0 0 10px;
    }
    &.selected {
      &:before {
        width: 9px;
        height: 100%;
        content: "   ";
        display: block;
        float: left;
        background: url(../../assets/img/game_switch_bg_left.png) no-repeat;
      }
      &:after {
        width: 9px;
        height: 100%;
        content: "   ";
        display: block;
        float: left;
        background: url(../../assets/img/game_switch_bg_right.png) no-repeat;
      }
      & > div {
        float: left;
        background: url(../../assets/img/game_switch_bg_center.png) repeat-x;
      }
      .game_link {
        color: #fff;
      }
    }
  }
  .game_index_link .game_link {
    width: auto;
  }
}

.arrow_drop_menu,
.drop_menu {
  .ant-popover-arrow {
    width: 20px;
    height: 20px;
    border-width: 10px;
  }
  .drop_menu_content {
    max-width: 1120px;
    overflow: hidden;
    padding: 0 5px;
    .drop_menu_item {
      padding: 8px 0 3px 0;
      width: 130px;
      margin: 10px 0;
      text-align: center;
      float: left;
      color: @text-color;
      border: 1px solid #fff;
      &.selected {
        background: #e6f7ff;
        border: 1px solid #ace0ff;
        border-radius: 5px;
        color: #1890ff;
      }
      .game_logo {
        display: block;
        width: 70px;
        height: 70px;
        margin: 0 auto 10px auto;
      }
    }

    .drop_menu_studio {
      border-bottom: 1px solid #ebebeb;
      &:last-child {
        border-bottom: none;
      }
      display: flex;
      padding: 8px 0;
      label {
        width: 60px;
        font-weight: bold;
        color: rgba(0, 0, 0, 0.75);
        line-height: 50px;
        padding: 0 0 0 8px;
      }
      .drop_menu_studio_game {
        flex: 1;
        a {
          display: block;
          float: left;
          width: 210px;
          height: 50px;
          padding: 7px;
          color: rgba(0, 0, 0, 0.75);
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          img {
            width: 35px;
            height: 35px;
            margin: 0 10px 0 0;
            vertical-align: middle;
          }
          span {
            vertical-align: middle;
          }
          &.selected {
            background: #e6f7ff;
            border: 1px solid #91d5ff;
            border-radius: 5px;
          }
        }
      }
    }
  }
}
</style>

<style lang="less">
.drop_menu > .ant-popover-content > .ant-popover-arrow {
  left: 60px;
}
.ant-popover-inner-content {
  padding: 5px 16px;
}
.arrow_drop_menu {
  margin: 0 0 0 -120px;
}
.arrow_drop_menu > .ant-popover-content > .ant-popover-arrow {
  left: 60px;
}
.drop_menu > .ant-popover-content .ant-popover-inner-content {
  max-height: calc(100vh - 100px);
  overflow: auto;
  &::-webkit-scrollbar {
    width: 5px; /*滚动条宽度*/
    height: 5px; /*滚动条高度*/
    background: #f1f1f1;
    margin: 0 5px 0 0;
  }

  /*定义滑块 内阴影+圆角*/
  &::-webkit-scrollbar-thumb {
    border-radius: 3px; /*滚动条的圆角*/
    background-color: #bbb; /*滚动条的背景颜色*/
  }
}

.game_type_swap {
  text-align: right;
  font-size: 12px;
  color: #1890ff;
  span {
    cursor: pointer;
  }
}
</style>
